var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMensaje32X32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22673 6.69336C5.31234 6.69336 4.56006 7.44564 4.56006 8.36003V21.6934C4.56006 22.6077 5.31234 23.36 6.22673 23.36H10.0801C10.6323 23.36 11.0801 23.8077 11.0801 24.36C11.0801 24.9123 10.6323 25.36 10.0801 25.36H6.22673C4.20777 25.36 2.56006 23.7123 2.56006 21.6934V8.36003C2.56006 6.34107 4.20777 4.69336 6.22673 4.69336H25.7201C27.739 4.69336 29.3867 6.34107 29.3867 8.36003V21.7067C29.3867 23.7256 27.739 25.3734 25.7201 25.3734H18.8001C18.2478 25.3734 17.8001 24.9256 17.8001 24.3734C17.8001 23.8211 18.2478 23.3734 18.8001 23.3734H25.7201C26.6344 23.3734 27.3867 22.6211 27.3867 21.7067V8.36003C27.3867 7.44564 26.6344 6.69336 25.7201 6.69336H6.22673Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6881 23.9002C19.9421 24.3906 19.7504 24.9941 19.2599 25.248L10.6473 29.7079C9.80072 30.1312 8.7519 29.5131 8.81537 28.4976L8.81563 28.4935L9.09564 24.2935C9.13237 23.7424 9.60888 23.3255 10.1599 23.3622C10.711 23.399 11.1279 23.8755 11.0912 24.4265L10.8979 27.3259L18.3403 23.472C18.8307 23.2181 19.4341 23.4098 19.6881 23.9002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84009 12.8267C7.84009 12.2744 8.2878 11.8267 8.84009 11.8267H23.0934C23.6457 11.8267 24.0934 12.2744 24.0934 12.8267C24.0934 13.3789 23.6457 13.8267 23.0934 13.8267H8.84009C8.2878 13.8267 7.84009 13.3789 7.84009 12.8267Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9734 18.3333C14.9734 17.781 15.4211 17.3333 15.9734 17.3333H23.0934C23.6457 17.3333 24.0934 17.781 24.0934 18.3333C24.0934 18.8856 23.6457 19.3333 23.0934 19.3333H15.9734C15.4211 19.3333 14.9734 18.8856 14.9734 18.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMensaje32X32);
export default __webpack_public_path__ + "static/media/MENSAJE_32X32.aa5bf5463c3fcfc0f5ab6940bc8fbbbf.svg";
export { ForwardRef as ReactComponent };